export default "__VITE_ASSET__96eef338__"